import * as React from 'react';
import {ThemeProvider, createTheme} from '@mui/material/styles';
import {Box} from '@mui/material';

export default function NotFoundPage(props) {

    const theme = createTheme();

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{display: 'flex'}}>
                <Box
                    component="main"
                    sx={{
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'light'
                                ? theme.palette.grey[100]
                                : theme.palette.grey[900],
                        flexGrow: 1,
                        height: '100vh',
                        overflow: 'auto',
                    }}
                >
                    <div style={{"height": "20vh"}}></div>

                    <h1 style={{"fontSize": "130px", "margin": "0px", textAlign: "center"}}>404</h1>
                    <h2 style={{textAlign: "center"}}>Página no encontrada</h2>
                </Box>
            </Box>
        </ThemeProvider>
    )
}
